'use client';

import { useTranslations } from 'next-intl';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';
import { useToast } from '@/lib/hooks/use-toast';

export function Toaster() {
  const { toasts } = useToast();
  const t = useTranslations('common');

  return (
    // Radix's built-in screen-reader labels are English ("Notification",
    // "Notifications (F8)") — give them the UI language.
    <ToastProvider label={t('toastLabel')}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose aria-label={t('close')} />
          </Toast>
        );
      })}
      <ToastViewport label={t('toastRegionLabel', { hotkey: 'F8' })} />
    </ToastProvider>
  );
}
